import axios from 'axios';
import { message } from 'antd';
import {
  USERS_API,
} from '../../../constants/API';
import {
  REMOVE_FILTER
} from '../types';

function removeFilter(data) {
  return async(dispatch, getState) => {
      dispatch({
        type: REMOVE_FILTER,
        removingFilter: true,
      });
      try {
        const accessToken = await localStorage.getItem('accessToken');
        const { userData } = getState().AuthReducer;
        const postData = {
          ...data,
          userId: userData.id
        };
        const filteredOrder = await axios.post(`${USERS_API}/removeFilter`, postData, { headers: {"Authorization" : `Bearer ${accessToken}`} });
        console.log(filteredOrder)
        dispatch({
          type: REMOVE_FILTER,
          removingFilter: false,
        });
      } catch (e) {
        message.error(String(e));
        dispatch({
          type: REMOVE_FILTER,
          removingFilter: false,
        });
        console.log(e);
      }
  }
}
export default removeFilter;
